import React from 'react'
import { Menu } from './Menu'
import { Header } from './Header'

export const TopBar = () => {
  return (
    <>
        <Header />
        <Menu />
    </>
  )
}
